import Vue from 'vue'
import Hotjar from 'vue-hotjar'

Vue.use (Hotjar, {
  id: '3717998', // Hotjar Site ID
  isProduction: true
})